/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import loadMappingUrl from "url:../assets/images/load_mapping.png";

export const savingLoadingContent = `
## Project Management

Dexter allows you to save your transformation mappings and reload them later.

### Saving Your Work

Click the Save button in the toolbar to save your current mapping. This saves:
- All nodes and their positions
- All connections between nodes
- Transform configurations
- Project name and metadata

### Project Names

Projects are named "Untitled Mapping" by default. Click the project title in the toolbar to rename it. Project names should:
- Be descriptive of the transformation
- Use alphanumeric characters
- Be unique to avoid confusion

### Loading Projects

<img src="${loadMappingUrl}" alt="Open Mapping" style="max-width: 800px; height: auto; display: block; margin: 24px auto;" />

To load a saved project:
1. Click the Open Mapping button in the toolbar
2. Click a project from the list to open it

Your current work will be replaced when loading a project, so save any changes first.

### Export and Import

You can also export projects as JSON files:

**Export**: Click the "Export Mapping (JSON)" button to save a project file to your computer

**Import**: Click "Import Mapping" and select a JSON file to import a project

This is useful for:
- Backing up important mappings
- Sharing mappings with team members
- Version control
- Moving mappings between environments

### Demo Project

Click "Load Demo" to load a sample project that demonstrates Dexter's capabilities.
`;
